// extracted by mini-css-extract-plugin
export default {"tokenText":"HeaderIssueType-module__tokenText--ueO3Q","smallToken":"HeaderIssueType-module__smallToken--rVNy9"};